import { render } from "./HolidayList.vue?vue&type=template&id=32e1af4e"
import script from "./HolidayList.vue?vue&type=script&lang=js"
export * from "./HolidayList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__